import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Link } from "react-router-dom";

export default function WhatIsReiki() {
  const { t } = useLang();
  const sections = t("reiki.sections");
  return (
    <div data-testid="reiki-page" className="container-refined py-16 md:py-24">
      <div className="max-w-3xl">
        <p className="eyebrow">{t("reiki.eyebrow")}</p>
        <h1 className="mt-4 font-serif text-5xl md:text-6xl leading-[1.05] text-forest-900">{t("reiki.title")}</h1>
        <p className="mt-8 text-lg leading-relaxed text-forest-700 first-letter:font-serif first-letter:text-6xl first-letter:leading-none first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:text-wheat-700">
          {t("reiki.intro")}
        </p>
      </div>

      <div className="mt-16 max-w-2xl space-y-14">
        {Array.isArray(sections) && sections.map((s, i) => (
          <article key={i} data-testid={`reiki-section-${i}`}>
            <p className="text-xs uppercase tracking-[0.28em] text-wheat-700">Chapter {String(i + 1).padStart(2, "0")}</p>
            <h2 className="mt-3 font-serif text-3xl md:text-4xl text-forest-900">{s.h}</h2>
            <p className="mt-5 text-forest-700 leading-relaxed text-lg">{s.p}</p>
          </article>
        ))}
      </div>

      <div className="mt-20 card-warm max-w-3xl">
        <p className="font-serif text-2xl italic text-forest-900 leading-snug">
          &ldquo;Reiki does not ask you to become someone else. It simply invites what is already whole to be met.&rdquo;
        </p>
        <div className="mt-6 flex gap-3">
          <Link to="/book" className="btn-primary" data-testid="reiki-cta-book">{t("home.cta_book")}</Link>
          <Link to="/mission" className="btn-secondary" data-testid="reiki-cta-mission">{t("nav.mission")}</Link>
        </div>
      </div>
    </div>
  );
}
